module.exports = __webpack_public_path__ + "img/basic1.405b48a.png";